/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'attachment-file-solid': {
    width: 16,
    height: 16,
    viewBox: '0 0 25 25',
    data: '<path pid="0" d="M23.5 1h-12A1.5 1.5 0 0 0 10 2.5v14a4.5 4.5 0 0 1-9 0v-9a3 3 0 0 1 6 0v8a1.5 1.5 0 0 1-3 0V8a.5.5 0 0 0-1 0v7.5a2.5 2.5 0 0 0 5 0v-8a4 4 0 0 0-8 0v9A5.506 5.506 0 0 0 5.5 22c.169 0 .335-.01.5-.025V22h14.5a4.5 4.5 0 0 0 4.5-4.5v-15A1.5 1.5 0 0 0 23.5 1zm-4 17h-6a.5.5 0 0 1 0-1h6a.5.5 0 0 1 0 1zm2-3h-8a.5.5 0 0 1 0-1h8a.5.5 0 0 1 0 1zm0-3h-8a.5.5 0 0 1 0-1h8a.5.5 0 0 1 0 1zm.5-4a1 1 0 0 1-1 1h-7a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h7a1 1 0 0 1 1 1z"/>'
  }
})
